import { Button } from "components/Button/Button"
import { Form } from "components/Form/Form"
import { Input } from "components/Input/Input"
import { ErrorStatus } from "components/ErrorStatus/ErrorStatus"
import { EmpoLogoComplete } from "icons/EmpoLogoComplete"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { useSetPassword } from "services/users"

type FormValues = {
	password: string
	confirmPassword: string
}

const CLERK_TICKET = "__clerk_ticket"

export const SetPassword = () => {
	const navigate = useNavigate()
	const [form] = Form.useForm()
	const [ticketJson, setTicketJson] = useState<{ sid: string }>()
	const setPassword = useSetPassword()
	const onFinish = async ({ password }: FormValues) => {
		setPassword.mutate(
			{
				newPassword: password,
				invitationId: ticketJson?.sid || "",
			},
			{
				onSuccess() {
					navigate("/login")
				},
			},
		)
	}

	useEffect(() => {
		const urlParams = new URLSearchParams(location.search)
		const ticket = urlParams.get(CLERK_TICKET)?.split(".")[1]
		if (ticket) {
			const t = JSON?.parse(atob?.(ticket))
			setTicketJson(t)
		}
	}, [])

	return (
		<div className="flex w-sm flex-col items-center justify-center gap-8 rounded-2xl bg-white px-8 py-9 shadow-2xl">
			<EmpoLogoComplete className="h-12" />

			<h1 className="w-full font-headings text-xl font-bold">Set password</h1>

			<Form<FormValues>
				form={form}
				layout="vertical"
				name="reset-password"
				autoComplete="off"
				rootClassName="w-full"
				disabled={setPassword.isPending}
				onFinish={onFinish}
			>
				<Form.Item
					name="password"
					label="Password"
					dependencies={["confirmPassword"]}
					rules={[
						{
							required: true,
							min: 8,
							message: "Please input at least 8 characters.",
						},
					]}
				>
					<Input.Password className="w-full" />
				</Form.Item>
				<Form.Item
					name="confirmPassword"
					label="Confirm password"
					dependencies={["password"]}
					rules={[
						({ getFieldValue }) => ({
							required: true,
							validator(_, value) {
								if (!value || getFieldValue("password") === value) {
									return Promise.resolve()
								}
								return Promise.reject(new Error("The passwords do not match."))
							},
						}),
					]}
				>
					<Input.Password className="w-full" />
				</Form.Item>
				<Form.Item>
					<Button
						htmlType="submit"
						type="primary"
						className="w-full font-bold uppercase"
						loading={setPassword.isPending}
					>
						Confirm
					</Button>
				</Form.Item>

				<ErrorStatus show={setPassword.isError}>
					{setPassword.error?.message}
				</ErrorStatus>
			</Form>
		</div>
	)
}
